import script from "./CardTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CardTemplate.vue?vue&type=style&index=0&id=ea7ebd90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea7ebd90"]])

export default __exports__